import React from 'react';
import TypographyComponent from 'components/Typography/Typography';
import { pxToEm } from 'theme';
import palette from 'theme/palette';

type CardInfoProps = {
  title: string;
  subtitle1?: string;
  subtitle2?: string;
  categoryName?: string;
  brandName?: string;
  childrenNumber?: number | string;
  isCompactDescription?: boolean;
};

export function CardInfo({
  title,
  subtitle1,
  subtitle2,
  categoryName,
  brandName,
  childrenNumber,
  isCompactDescription,
}: CardInfoProps) {
  return (
    <>
      <TypographyComponent
        className="product-category-name"
        fontSize={pxToEm(10)}
        lineHeight="16px"
        fontWeight={600}
        color={palette.grey['A400']}
        textTransform="uppercase"
        noWrap
      >
        {subtitle1 || categoryName}
      </TypographyComponent>
      <TypographyComponent
        className="product-title"
        variant="body"
        fontWeight={600}
        fontSize={pxToEm(13)}
        lineHeight="20px"
        noWrap
      >
        {title}
      </TypographyComponent>
      <TypographyComponent
        variant="body"
        display="flex"
        alignItems="center"
        color={palette.grey['A400']}
        fontSize={pxToEm(12)}
        lineHeight="20px"
      >
        <TypographyComponent
          component="span"
          inherit
          noWrap
          textAlign={isCompactDescription ? 'center' : 'left'}
        >
          {subtitle2 || brandName}
        </TypographyComponent>
        {!!childrenNumber && (
          <TypographyComponent component="span" inherit>
            &nbsp;({childrenNumber})
          </TypographyComponent>
        )}
      </TypographyComponent>
    </>
  );
}
